<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="OpportunityDocuments" class="data-list-container">
    <vs-prompt
      :title="document.Id === 0 ? $t('Add New Document') : $t('Edit Document')"
      :accept-text="$t('Save')"
      :cancel-text="$t('Cancel')"
      @cancel="clearDocModal"
      @accept="saveDocument"
      @close="clearDocModal"
      :is-valid="isFormValid"
      :active.sync="activePrompt"
    >
      <VuePerfectScrollbar style="height: 400px!important" class="scroll-area p-4" :settings="settings">
        <form @submit.prevent>
          <div class="vx-row">
            <div class="vx-col w-full mt-4">
              <label class="vs-input--label">{{ $t('Document Type') }} *</label>
              <!-- <v-select 
                :options="docTypeOptions" 
                v-model="document.DocumentType" 
                :reduce="option => option.value"
                class="w-full"
              /> -->
              <vs-input v-model="document.DocumentType" class="w-full"  />
            </div>

            <div class="vx-col w-full mt-4">
            <label class="vs-input--label">{{ $t('Upload File') }} *</label>
            <input type="file" class="w-full p-2 border rounded" @change="onFileChange" accept=".pdf,.doc,.docx,.jpg,.png" />
          </div>

          <div class="vx-col w-full mt-4">
            <vs-input :label="$t('File Name') + ' *'" v-model="document.FileName" class="w-full" />
          </div>

          <div class="vx-col w-full mt-4">
            <vs-input :label="$t('File Extension')" v-model="document.FileExtension" class="w-full" readonly />
          </div>

            <div class="vx-col w-full mt-4">
              <vs-input :label="$t('Notes')" v-model="document.Notes" class="w-full" />
            </div>
          </div>
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>

    <vx-card class="mb-base" :title="$t('Opportunity Documents Details')">
      <div class="flex flex-wrap items-center justify-between mb-4">
        <vs-button 
          type="border" 
          icon-pack="feather" 
          icon="icon-plus" 
          @click="activePrompt = true"
          :disabled="!opportunity.Id || opportunity.Id <= 0"
        >
          {{ $t('Add Document') }}
        </vs-button>
      </div>

      <vs-table :data="docsList">
        <template slot="thead">
          <vs-th>{{ $t('Type') }}</vs-th>
          <vs-th>{{ $t('File') }}</vs-th>
          <vs-th>{{ $t('Notes') }}</vs-th>
          <vs-th>{{ $t('Status') }}</vs-th>
          <vs-th>{{ $t('Action') }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ $t(tr.DocumentType) }}</vs-td>
              <vs-td>{{ tr.FileName }}{{ tr.FileExtension }}</vs-td>
              <vs-td>{{ tr.Notes }}</vs-td>
              <vs-td>
                <vs-chip :color="tr.IsActive ? 'success' : 'warning'">
                  {{ tr.IsActive ? $t('Active') : $t('Inactive') }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <div class="flex items-center">
                  <feather-icon 
                    icon="DownloadIcon" 
                    svgClasses="w-5 h-5 hover:text-success cursor-pointer" 
                    @click.stop="downloadFile(tr)" 
                  />

                  <feather-icon 
                    icon="EditIcon" 
                    class="ml-2"
                    svgClasses="w-5 h-5 hover:text-primary cursor-pointer" 
                    @click.stop="editDoc(tr)" 
                  />

                  <feather-icon 
                    icon="TrashIcon" 
                    svgClasses="w-5 h-5 hover:text-danger cursor-pointer" 
                    class="ml-2" 
                    @click="openConfirm(tr)" 
                  />
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: { vSelect, VuePerfectScrollbar },
  props: {
    opportunity: { type: Object, required: true }
  },
  data() {
    return {
      activePrompt: false,
      document: {
        Id: 0,
        OpportunityId: null,
        DocumentType: '',
        FileName: '',
        FilePath: '',
        FileExtension: '',
        Notes: '',
        IsActive: true
      },
      settings: { maxScrollbarLength: 60, wheelSpeed: 0.30 }
    }
  },
  computed: {
    docTypeOptions() {
      return [
        { label: this.$t('Offering Memo'), value: 'Offering Memo' },
        { label: this.$t('Terms & Conditions'), value: 'Terms & Conditions' },
        { label: this.$t('Property Report'), value: 'Property Report' }
      ]
    },
    docsList() { return this.$store.state.OpportunitiesList.OpportunityDocuments; },
    isFormValid() {
      return this.document.DocumentType && this.document.FileName && this.document.FilePath;
    }
  },
  methods: {
    downloadFile(data) {
    if (!data.FilePath) {
      this.$vs.notify({
        title: 'Error',
        text: 'File path not found',
        color: 'danger'
      });
      return;
    }



  
    const link = document.createElement('a');
    link.href = data.FilePath;
    link.setAttribute('download', data.FileName + data.FileExtension);
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
    onFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;

  
    const fullFileName = file.name;
    const lastDotIndex = fullFileName.lastIndexOf('.');
    
    this.document.FileName = fullFileName.substring(0, lastDotIndex); 
    this.document.FileExtension = fullFileName.substring(lastDotIndex); 
    
 
    this.document.FilePath = `/uploads/documents/${fullFileName}`;
    

  },
  saveDocument() {

    if (!this.document.FileName || !this.document.FilePath || !this.document.DocumentType) {
      this.$vs.notify({ title: 'Warning', text: 'Please fill required fields', color: 'warning' });
      return;
    }

    this.document.OpportunityId = this.opportunity.Id;
    const action = this.document.Id > 0 ? "updateDocument" : "addDocument";
    
    this.$vs.loading();
    this.$store.dispatch(`OpportunitiesList/${action}`, this.document)
      .then(() => {
        this.$vs.loading.close();
        this.clearDocModal();
        this.$vs.notify({ title: this.$t('Success'), color: 'success' });
      })
      .catch(err => {
        this.$vs.loading.close();
        this.$vs.notify({ title: this.$t('Error'), text: err.message, color: 'danger' });
      });
  },
    editDoc(data) {
      this.document = JSON.parse(JSON.stringify(data));
      this.activePrompt = true;
    },
    clearDocModal() {
      this.document = { Id: 0, DocumentType: '', FileName: '', FilePath: '', FileExtension: '', Notes: '', IsActive: true, OpportunityId: this.opportunity.Id };
      this.activePrompt = false;
    },
    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm", color: "danger", title: this.$t("Confirm Delete"),
        text: this.$t("Are you sure?"), accept: this.acceptDelete
      });
    },
    acceptDelete() {
      this.$store.dispatch("OpportunitiesList/deleteDocument", this.rowDataForDelete.Id);
    }
  },
  created() {
    if (this.opportunity.Id) {
      this.$store.dispatch("OpportunitiesList/fetchOpportunityDocuments", this.opportunity.Id);
    }
  }
}
</script>